<!-- 榜单 -->
<template>
    <div class="cardlist" v-if="list.length>0">
        <div class="list_item" v-for="i,index in list" :key="index">
            <div class="item_name">{{i.name}}</div>
            <div class="item_1" v-for="j,index in i.middItemList" :key="index" @click="gourl(j)">
                <div class="item_nei">
                    <div class="item_num" :class="numclass(index)">{{index+1}}</div>
                    <div class="item_img">
                        <img :src="enn + j.picurl" alt="">
                    </div>
                    <div class="item_fae">
                        <div class="fae_name">{{j.name}}</div>
                        <div class="fae_ramerk">{{j.ramack}}</div>
                    </div>
                </div>
                <div class="heng" v-if="index+1!==i.middItemList.length"></div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {onMounted, ref,reactive } from 'vue'
import {GetCharts,Onclick} from '@/api'


const list = ref([])
const enn = ref()
const numclass = (num)=>{
    switch(num){
        case 0:
            return 'num1'
        case 1:
            return 'num2'
        case 2:
            return 'num3'
        default:
            return 'num4'
    }
}

const gourl = (val)=>{
    Onclick(val.id).then().catch()
    window.open(val.gourl)
}

onMounted(()=>{
    GetCharts().then(res=>{
        enn.value = process.env.VUE_APP_PIC_URL
        list.value = res
        list.value = list.value.filter(i=>{return i.middItemList.length>0})
    }).catch()
})

</script>

<style lang="scss" scoped>
.cardlist{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    padding: 0 2rem;
    padding-bottom: 5rem;
    // animation: opacityAll .3s ease-in;
    background: var(--bac-ground);
    .list_item{
        width: 36rem;
        // height: 30rem;
        overflow: hidden;
        margin: 1rem;
        border-radius: 1rem;
        border:1px solid #e7e7e7;
        .item_name{
            padding: 2rem 2rem 0rem 2rem;
            font-size: 1.25rem;
            font-weight: 500;
            color:var(--cardlist-item-name-color);
        }
        .item_1{
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 2rem 2rem 1.5rem 2rem;
            position: relative;
            .heng{
                width: 90%;
                border-bottom: 1px solid var(--cardlist-item-heng);
                position: absolute;
                top: 100%;
            }
            .item_nei{
                display: flex;
                align-items: center;
                cursor: pointer;
                .item_num{
                    display: block;
                    color: #f7d758;
                    font-weight: bold;
                    min-width: 26px;
                    max-width: 26px;
                    margin-right: 1rem;
                    font-size: 1rem;
                    font-style: italic;
                    &.num1{color:#f78437}
                    &.num2{color:#f9d64a}
                    &.num3{color:#dafdb4}
                    &.num4{color:#aeaead}
                }
                .item_img{
                    width: 50px;
                    height: 50px;
                    -webkit-box-flex: 0;
                    -ms-flex: none;
                    flex: none;
                    margin-right: 1rem;
                    position: relative;
                    border-radius: 0.85rem;
                    background: var(--cardlist-item-imgdiv);
                    img{
                        max-height: 100%;
                        vertical-align: unset;
                        padding: 0.5rem !important;
                        width: 50px;
                        height: 50px;
                        border-radius: 1rem;
                        // -webkit-transition: all .2s;
                        // -o-transition: all .2s;
                        // transition: all .2s;
                    }
                }
                .item_fae{
                    .fae_name{
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        overflow: hidden;
                        max-width: 100%;
                        font-size: 1rem;
                        padding: .3rem 0;
                        color:var(--cardlist-item-fae-name);
                    }
                    .fae_ramerk{
                        font-size: .8rem;
                        width: 23rem;
                        padding: .3rem 0;
                        color:var(--cardlist-item-fae-ramerk);
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                    }
                }
            }
            .item_nei:hover{
                .item_img{
                    img{
                        scale: 1.1;
                    }           
                }
            }
        }
    }
}
.footBei{
    position: absolute;
    cursor: pointer;
    left: 50%;
    bottom: 1rem;
    transform: translate(-50%, -50%);
    color:var(--header-text1);
}
</style>